import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { StaffCommentSubject } from '../../lib/types/models/staff-comment-subject/staff-comment-subject'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffCommentSubjects(input?: PaginationRequest) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.staffCommentSubjects.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<StaffCommentSubject>>()
}
